<template>
  <div class="sidearm-mm-gallery-thumb pa-1">
    <div
      class="sidearm-mm-gallery-thumb__inner relative bg-black overflow-hidden"
    >
      <aspect-ratio :ratio="'56.25%'">
        <img
          :src="gallery.images[0].medium"
          :alt="gallery.images[0].caption"
          class="sidearm-mm-gallery-thumb__image absolute w-100"
        />
        <a
          :href="`/galleries/?gallery=${gallery.id}`"
          target="_blank"
          class="sidearm-mm-gallery-thumb__overlay flex flex-align-center flex-justify-center w-100 h-100 absolute pa-1 text-decoration-none"
        >
          <span class="type-hero-small text-center">{{ gallery.title }}</span>
        </a>
      </aspect-ratio>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    gallery: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.sidearm-mm-gallery-thumb {
  &__image {
    top: 0;
    left: 0;
  }
  &__overlay {
    top: 0;
    left: 0;
    color: $color-white;
    background: rgba($color-black, 0.9);
    opacity: 0;
    transition: opacity 0.3s;
    &:hover,
    &:focus {
      opacity: 1;
    }
  }
}
</style>
